import React, { useRef, useEffect } from 'react';

const PARTICLE_COUNT = 30;
const COLORS = [
    'rgba(168, 85, 247, 0.40)',  // purple
    'rgba(255, 0, 128, 0.32)',   // pink
    'rgba(97, 218, 251, 0.32)',  // cyan
    'rgba(251, 191, 36, 0.24)',  // gold
];

const FloatingParticles = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        let animId;

        const resize = () => {
            const parent = canvas.parentElement;
            if (!parent) return;
            canvas.width = parent.offsetWidth;
            canvas.height = parent.offsetHeight;
        };
        resize();
        window.addEventListener('resize', resize);

        // Enhanced Particle Setup
        const PARTICLE_COUNT = 50;
        const particles = Array.from({ length: PARTICLE_COUNT }, () => ({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            r: Math.random() * 3 + 1, // Radius 1-4
            d: Math.random() * Math.PI * 2, // Density/Phase for wave
            vx: Math.random() * 0.2 - 0.1, // Horizontal drift
            vy: -1 * (Math.random() * 0.3 + 0.1), // Upward speed
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
        }));

        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = 'screen';

            // Set fixed shadow styles for all particles (major performance win)
            ctx.shadowBlur = 10;

            for (const p of particles) {
                // Organic movement
                p.d += 0.01;
                p.y += p.vy;
                p.x += Math.sin(p.d) * 0.5 + p.vx;

                // Wrap around edges
                if (p.y < -10) {
                    p.y = canvas.height + 10;
                    p.x = Math.random() * canvas.width;
                }
                if (p.x > canvas.width + 10) p.x = -10;
                if (p.x < -10) p.x = canvas.width + 10;

                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                ctx.fillStyle = p.color;
                ctx.shadowColor = p.color;
                ctx.fill();
            }

            animId = requestAnimationFrame(draw);
        };

        animId = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(animId);
            window.removeEventListener('resize', resize);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 0,
            }}
        />
    );
};

export default FloatingParticles;
